export default __webpack_public_path__ + "static/media/profile.5faf09a7.png";